import { render, staticRenderFns } from "./CustomerListItem.vue?vue&type=template&id=af2cbb44&scoped=true&"
import script from "./CustomerListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerListItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListItem.vue?vue&type=style&index=0&id=af2cbb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2cbb44",
  null
  
)

export default component.exports